import { CommonModule } from '@angular/common';
import { Component, inject, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DataTableDirective, DataTablesModule } from 'angular-datatables';
import { Subject } from 'rxjs';
import { LoaderComponent } from '../../../Component/Loader/loader/loader.component';
import { RouterModule } from '@angular/router';
import { ClusterFormComponent } from '../cluster-form/cluster-form.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ClusterService } from '../../../Model/Cluster/cluster.service';
import { CommonService } from '../../../Model/Common/common.service';

@Component({
  selector: 'app-cluster',
  standalone: true,
  imports: [FormsModule, CommonModule, DataTablesModule, LoaderComponent, RouterModule],
  templateUrl: './cluster.component.html',
  styleUrl: './cluster.component.scss'
})
export class ClusterComponent {
  @ViewChild(DataTableDirective, { static: false })
  dtElement!: DataTableDirective
  isDisabled: boolean = false;
  private modalService = inject(NgbModal);
  dtTrigger: Subject<any> = new Subject<any>();
  TableDatas: any[] = []
  public User: any = null
  filter = {
    SelectType: 1,
    ESS_ClusterMasterid: 0
  }
  dtoptions: DataTables.Settings = {};
  constructor(private cluster : ClusterService,
     protected common: CommonService,
  ){
    this.common.getPageRights();
    this.dtoptions = { ...this.common.commonDToptions };
  }

  ngOnInit(): void {
    this.getData();
  }
  ngAfterViewInit(): void {
    this.dtTrigger.next(null);
  }
  ngOnDestroy(): void {
    // Do not forget to unsubscribe the event
    this.dtTrigger.unsubscribe();
  }

  add(id: number,Code: string, Name: string, BranchId: any) {
    const modalRef = this.modalService.open(ClusterFormComponent, {
      size: 'md',
      backdrop: 'static',
      centered: true,
      windowClass: 'confirmation-modal'
    });
    modalRef.componentInstance.id = id;
    modalRef.componentInstance.Code = Code;
    modalRef.componentInstance.Name = Name;
    modalRef.componentInstance.BranchId = BranchId;
    modalRef.result.then((result: any) => {
      if (result) {
        this.getData();
      }
    }).catch(() => {
      // Modal dismissed
    });
  }
  getData(){
    this.isDisabled = true;
    this.cluster.ClusterMasterLoad(this.filter).subscribe({
      next: (response) => {
        if(response){
          this.TableDatas = Object.values(response.Table);
          this.isDisabled = false;
          this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.destroy();
            this.dtTrigger.next(null);
          });
        }
      },
      complete: () => { this.isDisabled = false},
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }
}
